<template>
  <div class="setting_content">
    <div class="setting_content_main">
      <div class="setting_content_heading">
        <h2 class="setting_content_title">
          {{ labelProperties.headTitle }}
        </h2>
        <div class="setting_content_heading_btn">
          <button
              class="setting_btn_secondary setting_btn_medium"
              @click="openPopupAddCategory"
          >
            {{ labelProperties.buttonAddCategory }}
          </button>
          <ModalCategory
              v-show="isVisibleModalCategory"
              :category="category"
              @close="closeModalCategory"
              @submit="addCategory()"
          />
        </div>
      </div>
      <div class="setting_category_header">
        <div class="setting_category_header_sorting">
          {{ labelProperties.headerSorting }}
        </div>
        <div class="setting_category_header_display">
          {{ labelProperties.headerSelect }}
        </div>
        <div class="setting_category_header_content">
          {{ labelProperties.headerContent }}
        </div>
        <div class="setting_category_header_operation">
          {{ labelProperties.headerOperation }}
        </div>
      </div>
      <draggable
          :list="categories"
          handle=".handle"
          v-bind="{ disabled: false }"
          @change="updateDisplay"
          @sort="updateCategory"
          class="setting_category"
      >
        <div class="setting_category_wrapper" v-for="(subCategory, index) in categories" :key="index">
          <div class="setting_category_item" v-if="subCategory && !subCategory.categoryDeleted">
            <div class="setting_category_item_sorting">
              <svg class="setting_category_item_sorting_icon handle evt-click"
                   width="10" height="12" xmlns="http://www.w3.org/2000/svg">
                <g fill="#aaa" fill-rule="evenodd">
                  <path d="M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z"/>
                </g>
              </svg>
            </div>
            <div class="setting_category_item_display">
              <div class="setting_category_item_display_arrow evt-click" v-if="!subCategory.isCollapse"
                   @click.prevent="changeCollapse(index)">
                <svg width="6" height="6" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 0l3 6H0z" fill="#333" fill-rule="evenodd"/>
                </svg>
              </div>
              <div class="setting_category_item_display_arrow is_open evt-click" v-else
                   @click.prevent="changeCollapse(index)">
                <svg width="6" height="6" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 0l3 6H0z" fill="#333" fill-rule="evenodd"/>
                </svg>
              </div>
            </div>
            <div class="setting_category_item_content setting_word_break">
              {{ subCategory.categoryName }}
            </div>
            <div class="setting_category_item_operation">
              <div class="setting_category_item_operation_add">
                <a class="setting_category_item_operation_add_btn" @click="openAddItemModal(index, -1)">
                  {{ labelProperties.addItemLink }}
                </a>
                <DetailItemModal
                    v-show="isVisibleEditItemModals[index] && isVisibleEditItemModals[index].status"
                    :item="item"
                    :resourceFields="resourceFields"
                    :companyResourceFields="companyResourceFields"
                    @updateResourceFields="updateResourceFields"
                    @updateCompanyResourceFields="updateCompanyResourceFields"
                    @close="closeEditItemModal(index, -1)"
                    @submit="addItemToCategory(categoryIndex, itemIndex)"
                />
              </div>
              <div class="setting_category_item_operation_edit">
                <button class="setting_btn_secondary setting_btn_medium" @click="openPopUpEditCategory(index)">
                  {{ labelProperties.buttonEditItem }}
                </button>
                <ModalCategory
                    v-show="isVisibleEditModalCategories[index]"
                    :category="category"
                    @close="closeModalEditCategory(index)"
                    @submit="editCategory(index)"
                />
              </div>
              <button class="setting_btn_delete setting_btn_medium" @click="openPopupDeleteCategory(index)">
                {{ labelProperties.buttonDelete }}
              </button>
            </div>
          </div>
          <div v-if="subCategory && !subCategory.categoryDeleted">
            <draggable
                v-if="subCategory.isCollapse"
                :list="subCategory.item"
                handle=".handle"
                @change="logChangeData"
                @sort="updateCategory"
            >
              <div class="align-items-center" v-for="(resource, subIndex) in subCategory.item" :key="subIndex">
                <template v-if="resource.itemDeleted === undefined || !resource.itemDeleted">
                  <div class="setting_column_item" :class="resource.isDeletedByMainSystem ? 'item-deleted-setting' : ''"
                       :title="resource.isDeletedByMainSystem ? entrySettingNotificationProperty.TITLE_ITEM_DELETED : ''">
                    <div class="setting_column_item_sorting handle evt-click">
                      <svg
                          class="setting_column_item_sorting_icon"
                          width="10" height="12" xmlns="http://www.w3.org/2000/svg">
                        <g fill="#aaa" fill-rule="evenodd">
                          <path d="M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z"/>
                        </g>
                      </svg>
                    </div>
                    <div class="setting_column_item_content setting_word_break">
                      {{ resource.itemName }}
                    </div>
                    <div class="setting_column_item_operation">
                      <div class="setting_column_item_operation_add">
                        <button class="setting_btn_secondary setting_btn_medium"
                                @click="openAddItemModal(index, subIndex)">
                          {{ labelProperties.buttonEditItem }}
                        </button>
                        <DetailItemModal
                            v-show="isVisibleEditItemModals[index] && isVisibleEditItemModals[index].subModal[subIndex]"
                            :item="item"
                            :resourceFields="resourceFields"
                            :companyResourceFields="companyResourceFields"
                            @updateResourceFields="updateResourceFields"
                            @updateCompanyResourceFields="updateCompanyResourceFields"
                            @close="closeEditItemModal(index, subIndex)"
                            @submit="addItemToCategory(categoryIndex, itemIndex)"
                        />
                      </div>
                      <button class="setting_btn_delete setting_btn_medium" @click="openPopupDeleteItem(index, subIndex)">
                        {{ labelProperties.buttonDelete }}
                      </button>
                    </div>
                  </div>
                </template>
              </div>
            </draggable>
          </div>
        </div>
      </draggable>
    </div>
    <div>
      <div class="setting_content_sub" :id="idSetScroll">
        <div class="setting_job_resource">
          <div :id="'dispatch_job_heading_search_item_' + useType">
            <div class="setting_options_search d-flex justify-content-end">
              <div class="setting_item_display_arrow evt-click" :class="{'is_open': !isHideItemJob}"
                   @click.prevent="hideItemResource(ITEM_JOB)">
                <svg width="6" height="6" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 0l3 6H0z" fill="#333" fill-rule="evenodd"/>
                </svg>
              </div>
              <button
                  class="setting_btn_secondary setting_btn_medium"
                  @click="refreshResourceList"
              >
                {{ screenLabelsProperties.REFRESH_RESOURCE_BUTTON }}
              </button>
            </div>
            <div class="setting_options_search setting_options_search_customize">
              <p class="setting_options_search_label">
                {{ screenLabelsProperties.SEARCH_DISPATCH_JOB_LABEL }}
              </p>
              <div class="setting_options_search_box">
                <input
                    class="setting_form_text"
                    type="text"
                    :placeholder="screenLabelsProperties.SEARCH_PLACEHOLDER"
                    v-model="computedPropertyJobResource"
                    v-on:keyup.enter="getJobResourceFields"
                />
                <button
                    class="setting_btn_primary"
                    v-on:click.prevent="getJobResourceFields"
                >
                  <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
                    <g fill="none" fill-rule="evenodd">
                      <circle stroke="#FFF" stroke-width="2" cx="6.5" cy="6.5" r="5.5"/>
                      <path fill="#FFF" d="M10 11.98L11.98 10l4.242 4.243-1.98 1.98z"/>
                    </g>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="setting_options_wrapper" :id="'dispatch_job_item_resource_wrap_' + useType" style="display: block;">
            <div class="setting_options_category">
              <div v-for="(jobCategory, indexCategory) in jobCategories" :key="indexCategory">
                <template v-if="checkEmptyResourceCategory(resourceFields, jobCategory.name) && jobCategory.is_display === 1">
                  <p class="setting_options_category_name jobs mt-3">
                    {{ jobCategory.display_name }}
                  </p>
                  <draggable :group="{ name: 'item-job-or-company', put: false, pull: 'clone' }" :list="resourceFields">
                    <template v-for="resourceField in resourceFields">
                      <div class="setting_options_category_item"
                           v-if="resourceField && resourceField.property_category_name === jobCategory.name && resourceField.isUsed && !resourceField.isUsed.includes(useType) && resourceField.name && !jobSettingProperty.ITEM_RESOURCE_UNSUPPORT.includes(resourceField.name)">
                        <svg class="setting_options_category_item_icon" width="10" height="12" xmlns="http://www.w3.org/2000/svg">
                          <g fill="#aaa" fill-rule="evenodd">
                            <path d="M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z" />
                          </g>
                        </svg>
                        <span class="setting_options_category_item_name">
                          {{ resourceField.display_name }}
                        </span>
                      </div>
                    </template>
                  </draggable>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="setting_company_resource">
          <div :id="'dispatch_company_heading_search_item_' + useType">
            <div class="setting_options_search_job_resource d-flex justify-content-end">
              <div class="setting_item_display_arrow evt-click" :class="{'is_open': !isHideItemCompany}"
                   @click.prevent="hideItemResource(ITEM_COMPANY)">
                <svg width="6" height="6" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 0l3 6H0z" fill="#333" fill-rule="evenodd"/>
                </svg>
              </div>
              <button class="setting_btn_secondary setting_btn_medium" @click="refreshCompanyResourceList">
                {{ screenLabelsProperties.REFRESH_RESOURCE_BUTTON }}
              </button>
            </div>
            <div class="setting_options_search_job_resource setting_options_search_customize">
              <p class="setting_options_search_label">
                {{ listLabelProperties.SEARCH_LABEL }}
              </p>
              <div class="setting_options_search_box">
                <input
                    class="setting_form_text"
                    type="text"
                    :placeholder="screenLabelsProperties.SEARCH_PLACEHOLDER"
                    v-model="computedPropertyCompanyResource"
                    v-on:keyup.enter="getCompanyResourceFields"
                />
                <button class="setting_btn_primary" v-on:click.prevent="getCompanyResourceFields">
                  <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
                    <g fill="none" fill-rule="evenodd">
                      <circle stroke="#FFF" stroke-width="2" cx="6.5" cy="6.5" r="5.5"/>
                      <path fill="#FFF" d="M10 11.98L11.98 10l4.242 4.243-1.98 1.98z"/>
                    </g>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="setting_options_wrapper" :id="'dispatch_company_item_resource_wrap_' + useType" style="display: block;">
            <div class="setting_options_category">
              <template v-for="companyCategory in companyCategories">
                <template v-if="checkEmptyResourceCategory(companyResourceFields, companyCategory.name) && companyCategory.is_display === 1">
                  <p class="setting_options_category_name setting_category_company mt-3">
                    {{ companyCategory.display_name }}
                  </p>
                  <draggable :group="{ name: 'item-job-or-company', put: false, pull: 'clone'}"
                             :list="companyResourceFields">
                    <template v-for="companyResourceField in companyResourceFields">
                      <div class="setting_options_category_item"
                           v-if="companyResourceField.property_category_name === companyCategory.name && companyResourceField.isUsed && !companyResourceField.isUsed.includes(useType)">
                        <svg class="setting_options_category_item_icon" width="10" height="12" xmlns="http://www.w3.org/2000/svg">
                          <g fill="#aaa" fill-rule="evenodd">
                            <path d="M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z" />
                          </g>
                        </svg>
                        <span class="setting_options_category_item_name">
                          {{ companyResourceField.display_name }}
                        </span>
                      </div>
                    </template>
                  </draggable>
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="setting_modal" v-if="isVisibleModalConfirmDeleteItem">
      <div class="setting_modal_box">
        <div class="setting_modal_box_body">
          <div class="setting_modal_box_close" @click="closePopupDeleteItem">
            <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg">
              <g fill="#AAA" fill-rule="evenodd">
                <path d="M.255 1.545l.99-.99 9.9 9.9-.99.99z" />
                <path d="M10.155.555l.99.99-9.9 9.9-.99-.99z" />
              </g>
            </svg>
          </div>
          <p class="setting_modal_box_text">
            {{ detailMessages.confirmDeleteItemMessage }}
          </p>
        </div>
        <div class="setting_modal_box_actions">
          <button class="setting_btn_outline" @click="closePopupDeleteItem">
            {{ labelProperties.buttonCancel }}
          </button>
          <button
              class="setting_btn_primary"
              @click="confirmDeleteItem()"
          >
            {{ labelProperties.buttonOk }}
          </button>
        </div>
      </div>
    </div>
    <div class="setting_modal" v-if="isVisibleModalConfirmDeleteCategory">
      <div class="setting_modal_box modal_confirm_delete_category">
        <div class="setting_modal_box_body">
          <div class="setting_modal_box_close" @click="closePopupDeleteCategory">
            <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg">
              <g fill="#AAA" fill-rule="evenodd">
                <path d="M.255 1.545l.99-.99 9.9 9.9-.99.99z" />
                <path d="M10.155.555l.99.99-9.9 9.9-.99-.99z" />
              </g>
            </svg>
          </div>
          <p class="setting_modal_box_text">
            {{ detailMessages.confirmDeleteCategoryMessage }}
          </p>
        </div>
        <div class="setting_modal_box_actions">
          <button class="setting_btn_outline" @click="closePopupDeleteCategory">
            {{ labelProperties.buttonCancel }}
          </button>
          <button
              class="setting_btn_primary"
              @click="confirmDeleteCategory()"
          >
            {{ labelProperties.buttonOk }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueToast from "vue-toast-notification";
import draggable from "vuedraggable";
import DetailItemModal from "./ModalComponents/DetailItemModal.vue";
import ModalCategory from "./ModalComponents/ModalAddCategory";
import notification from "../../../../properties/job_screen/job-notifications.json";
import maxLengthItem from "../../../../properties/job_screen/detail_tab/detail-maxlength.json";
import labelProperties from "../../../../properties/job_screen/detail_tab/detail-labels.json";
import generalService from "../../../../services/GeneralService";
import screenLabelsProperties from "../../../../properties/entry_screen/screen_tab/screen-labels.json";
import * as generalLabels from "../../../../properties/general_page/generalpage-labels.json";
import jobSettingProperty from "../../../../properties/job_screen/job-screen.json";
import detailMessages from "../../../../properties/job_screen/detail_tab/detail-messages.json";
import listLabelProperties from "../../../../properties/job_screen/list_tab/list-labels.json";
import entrySettingNotificationProperty from "../../../../properties/entry_screen/notifications.json";

Vue.use(VueToast);
const ITEM_JOB = 1;
const ITEM_COMPANY = 2;

export default {
  name: "DetailInformationTab",
  props: [
    "categories",
    "groupName",
    "resourceFields",
    "jobCategories",
    "property",
    "useType",
    "userId",
    "companyCategories",
    "companyResourceFields",
    "propertySearchCompany"
  ],
  components: {
    draggable,
    DetailItemModal,
    ModalCategory
  },
  data() {
    return {
      isVisibleEditItemModals: [],
      categoryIndex: -1,
      itemIndex: -1,
      categoryIndexDelete: 0,
      itemIndexDelete: 0,
      item: {
        itemName: "",
        itemDeleted: false,
        resourceField: [],
      },
      labelProperties: labelProperties,
      notification: notification,
      maxLengthItem: maxLengthItem,
      detailMessages: detailMessages,
      listLabelProperties: listLabelProperties,
      screenLabelsProperties: screenLabelsProperties,
      entrySettingNotificationProperty:entrySettingNotificationProperty,
      jobSettingProperty: jobSettingProperty,
      idSetScroll: "menu-search-item-dispatch-job-tab-detail",
      log: {
        info: {},
      },
      isVisibleModalCategory: false,
      category: {
        categoryName: "",
        categoryDeleted: false,
        categoryDisplay: -1,
        item: [],
      },
      isVisibleEditModalCategories: [],
      isVisibleModalConfirmDeleteCategory: false,
      isVisibleModalConfirmDeleteItem: false,
      indexCategoryRemove: -1,
      isHideItemJob: false,
      isHideItemCompany: false,
      ITEM_JOB: ITEM_JOB,
      ITEM_COMPANY: ITEM_COMPANY
    };
  },
  computed: {
    computedPropertyJobResource: {
      get() {
        return this.property;
      },
      set(value) {
        this.$emit("updatedProperty", value);
      },
    },
    computedPropertyCompanyResource: {
      get() {
        return this.propertySearchCompany;
      },
      set(value) {
        this.$emit("updatedSearchCompanyProperty", value);
      },
    },
  },

  methods: {
    hideItemResource(typeOfItem) {
      let elementHideItemJob = document.getElementById("dispatch_job_item_resource_wrap_" + this.useType);
      let elementHideItemCompany = document.getElementById("dispatch_company_item_resource_wrap_" + this.useType);

      if(!elementHideItemJob && !elementHideItemCompany){
        return;
      }

      let heightOfMenu = this.getHeightMenuSearch();
      let elementJobHeadingSearch = document.getElementById("dispatch_job_heading_search_item_" + this.useType);
      let elementCompanyHeadingSearch = document.getElementById("dispatch_company_heading_search_item_" + this.useType);
      if(!elementJobHeadingSearch || !elementCompanyHeadingSearch){
        return;
      }

      let boundJobHeadingSearch = elementJobHeadingSearch.getBoundingClientRect();
      let boundCompanyHeadingSearch = elementCompanyHeadingSearch.getBoundingClientRect();
      let heightFinal = heightOfMenu - (boundJobHeadingSearch.y + boundJobHeadingSearch.height);
      let companyHeight = boundCompanyHeadingSearch.height;
      let jobHeight = boundJobHeadingSearch.height;
      let isDisplayJob = elementHideItemJob.style.display;
      let isDisplayCompany = elementHideItemCompany.style.display;
      switch (typeOfItem) {
        case ITEM_JOB:
          this.isHideItemJob = !this.isHideItemJob;
          isDisplayJob = this.isHideItemJob ? 'none':'block';
          break;
        case ITEM_COMPANY:
          this.isHideItemCompany = !this.isHideItemCompany;
          isDisplayCompany = this.isHideItemCompany ? 'none':'block';
          break;
      }

      if(!this.isHideItemCompany && !this.isHideItemJob){
        heightFinal = (heightFinal + jobHeight)/2;
      }
      elementHideItemJob.setAttribute("style","display: " + isDisplayJob + ";height: "+ (heightFinal - companyHeight) + "px !important");
      elementHideItemCompany.setAttribute("style", "display: " + isDisplayCompany + ";height: "+ (heightFinal - jobHeight) + "px !important");
      this.$emit("updateScrollMenu","");
    },

    getHeightMenuSearch(){
      let windowInnerHeight = window.innerHeight;
      let elementFooter = document.getElementById("setting_footer").getBoundingClientRect();
      if (!elementFooter){
        return;
      }
      return (windowInnerHeight - elementFooter.height);
    },

    checkEmptyResourceCategory(resources, name) {
      return resources.filter(resource => resource.isUsed && !resource.isUsed.includes(this.useType) && resource.property_category_name === name).length !== 0;
    },

    async closePopupDeleteCategory(){
      this.createLog(
          "Menu " + generalLabels.THIRD_TAB + "-Tab " + jobSettingProperty.DETAIL_INFORMATION_TAB_TITLE +
          " Popup confirm delete category-Click button " + labelProperties.buttonCancel
      );
      await this.$emit("sendLogger", this.log);
      this.isVisibleModalConfirmDeleteCategory = false;
      this.$emit("updateEditingStatus", false);
    },

    async openPopupDeleteCategory(index) {
      this.createLog(
          "Menu " + generalLabels.THIRD_TAB + "-Tab " + jobSettingProperty.DETAIL_INFORMATION_TAB_TITLE +
          "-Click button " + labelProperties.buttonDelete
      );
      await this.$emit("sendLogger", this.log);
      this.closeAllModal();
      this.isVisibleModalConfirmDeleteCategory = true;
      this.indexCategoryRemove = index;
      this.$emit("updateEditingStatus", true);
    },

    async confirmDeleteCategory() {
      this.createLog(
          "Menu " + generalLabels.THIRD_TAB + "-Tab " + jobSettingProperty.DETAIL_INFORMATION_TAB_TITLE +
          " Popup confirm delete category-Click button " + labelProperties.buttonOk
      );
      await this.$emit("sendLogger", this.log);
      this.categories[this.indexCategoryRemove].categoryDeleted = true;
      this.updateDisplay();
      this.isVisibleModalConfirmDeleteCategory = false;
      this.$eventBus.$emit("unSaved", true);
      this.updateCategory();
      this.$emit("getJobResourceFields", this.log.hash);
      this.$emit("getCompanyResourceFields", this.log.hash);
      this.$emit("updateEditingStatus", false);
    },

    async openPopupDeleteItem(categoryIndex, itemIndex) {
      this.createLog(
          "Menu " + generalLabels.THIRD_TAB + "-Tab " + jobSettingProperty.DETAIL_INFORMATION_TAB_TITLE +
          "-Click button " + labelProperties.buttonDelete
      );
      await this.$emit("sendLogger", this.log);
      this.closeAllModal();
      this.categoryIndexDelete = categoryIndex;
      this.itemIndexDelete = itemIndex;
      this.isVisibleModalConfirmDeleteItem = true;
      this.$emit("updateEditingStatus", true);
    },

    async confirmDeleteItem() {
      this.createLog(
          "Menu " + generalLabels.THIRD_TAB + "-Tab " + jobSettingProperty.DETAIL_INFORMATION_TAB_TITLE +
          " Popup confirm delete item-Click button " + labelProperties.buttonOk
      );
      await this.$emit("sendLogger", this.log);
      this.categories[this.categoryIndexDelete].item[this.itemIndexDelete].itemDeleted = true;
      this.isVisibleModalConfirmDeleteItem = false;
      this.$eventBus.$emit("unSaved", true);
      this.updateCategory();
      this.$emit("getJobResourceFields", this.log.hash);
      this.$emit("getCompanyResourceFields", this.log.hash);
      this.$emit("updateEditingStatus", false);
    },

    closeAllModal() {
      this.isVisibleModalCategory = false;
      this.isVisibleEditModalCategories.fill(false);
      this.isVisibleEditModalCategories = JSON.parse(JSON.stringify(this.isVisibleEditModalCategories));
      this.isVisibleEditItemModals.forEach((modal, index) => {
        if (modal) {
          modal.status = false;
          modal.subModal.fill(false);
        } else {
          this.isVisibleEditItemModals[index] = {
            status: false,
            subModal: []
          }
        }
      });
      this.isVisibleEditItemModals = JSON.parse(JSON.stringify(this.isVisibleEditItemModals));
      this.isVisibleModalConfirmDeleteItem = false;
      this.isVisibleModalConfirmDeleteCategory = false;
      this.refreshItem();
    },

    async openAddItemModal(categoryIndex, itemIndex) {
      if (itemIndex === -1) {
        this.createLog("Menu " + generalLabels.THIRD_TAB + " - Tab " + jobSettingProperty.DETAIL_INFORMATION_TAB_TITLE + " - Click " + labelProperties.addItemLink);
      } else {
        this.createLog("Menu " + generalLabels.THIRD_TAB + " - Tab " + jobSettingProperty.DETAIL_INFORMATION_TAB_TITLE + " - Click button " + labelProperties.buttonEditItem);
      }
      await this.$emit("sendLogger", this.log);
      this.categoryIndex = categoryIndex;
      this.itemIndex = itemIndex;
      if (!this.isVisibleEditItemModals[categoryIndex]) {
        this.isVisibleEditItemModals[categoryIndex] = {
          status: false,
          subModal: []
        }
      }

      this.closeAllModal();
      if (itemIndex !== -1) {
        this.item = JSON.parse(JSON.stringify(this.categories[categoryIndex].item[itemIndex]));
        this.isVisibleEditItemModals[categoryIndex].subModal[itemIndex] = true;
        this.isVisibleEditItemModals = JSON.parse(JSON.stringify(this.isVisibleEditItemModals));
      } else {
        this.isVisibleEditItemModals[categoryIndex].status = true;
        this.isVisibleEditItemModals = JSON.parse(JSON.stringify(this.isVisibleEditItemModals));
      }

      this.$emit("updateEditingStatus", true);
    },

    async editCategory(index) {
      this.createLog(
          "Menu " + generalLabels.THIRD_TAB + "-Tab " + jobSettingProperty.DETAIL_INFORMATION_TAB_TITLE +
          "-Click button " + labelProperties.saveCategoryButton
      );
      await this.$emit("sendLogger", this.log);
      if (!this.validateInputCategory(this.category)) {
        return;
      }

      this.categories[index] = JSON.parse(JSON.stringify(this.category));
      this.$eventBus.$emit("unSaved", true);
      this.updateCategory();
      await this.closeModalEditCategory(index, true);
    },

    async closeModalEditCategory(index, isEditCategory) {
      if (!isEditCategory){
        this.createLog(
            "Menu " + generalLabels.THIRD_TAB + "-Tab " + jobSettingProperty.DETAIL_INFORMATION_TAB_TITLE +
            "-Click button " + labelProperties.buttonCancel
        );
        await this.$emit("sendLogger", this.log);
      }

      this.refreshCategory();
      this.isVisibleEditModalCategories[index] = false;
      this.$emit("updateEditingStatus", false);
    },

    async openPopUpEditCategory(index) {
      this.createLog(
          "Menu " + generalLabels.THIRD_TAB + "-Tab " + jobSettingProperty.DETAIL_INFORMATION_TAB_TITLE +
          "-Click button " + labelProperties.buttonEditItem
      );
      await this.$emit("sendLogger", this.log);
      this.closeAllModal();
      this.refreshCategory();
      this.category = JSON.parse(JSON.stringify(this.categories[index]));
      this.isVisibleEditModalCategories[index] = true;
      this.$emit("updateEditingStatus", true);
    },

    changeCollapse(index) {
      if (!this.categories || !this.categories[index].item || this.checkCategoryItemsLength(index) === 0) {
        return;
      }

      this.categories[index].isCollapse = !this.categories[index].isCollapse;
      this.updateCategory();
    },

    checkCategoryItemsLength(index) {
      return this.categories[index].item.filter(i => !i.itemDeleted || i.itemDeleted === false).length;
    },

    updateCategory() {
      this.$emit("updateCategory", this.categories);
    },

    async openPopupAddCategory() {
      this.createLog(
          "Menu " + generalLabels.THIRD_TAB + "-Tab " + jobSettingProperty.DETAIL_INFORMATION_TAB_TITLE +
          "-Click button " + labelProperties.buttonAddCategory
      );
      await this.$emit("sendLogger", this.log);
      this.category = {};
      this.closeAllModal();
      this.isVisibleModalCategory = true;
      this.$emit("updateEditingStatus", true);
    },

    async closeModalCategory() {
      this.log.hash = generalService.createHashCode(15);
      this.createLog(
          "Menu " +generalLabels.THIRD_TAB + "-Tab " + jobSettingProperty.DETAIL_INFORMATION_TAB_TITLE +
          " Popup category-Click button " + labelProperties.closeModal
      );
      await this.$emit("sendLogger", this.log);
      this.isVisibleModalCategory = false;
      this.$emit("updateEditingStatus", false);
    },

    async addCategory() {
      this.log.hash = generalService.createHashCode(15);
      this.createLog(
          "Menu " + generalLabels.THIRD_TAB + "-Tab " + jobSettingProperty.DETAIL_INFORMATION_TAB_TITLE +
          " Popup category-Click button " + labelProperties.saveCategoryButton
      );
      await this.$emit("sendLogger", this.log);
      if (!this.validateInputCategory(this.category)) {
        return;
      }

      let newCategory = {
        categoryName: this.category.categoryName,
        categoryDeleted: false,
        categoryDisplay: -1,
        item: [],
        isCollapse: false
      };

      this.categories.push(JSON.parse(JSON.stringify(newCategory)));
      this.isVisibleEditModalCategories.fill(false);
      this.updateDisplay();
      this.refreshCategory();
      this.$eventBus.$emit("unSaved", true);
      this.isVisibleModalCategory = false;
      this.$emit("updateEditingStatus", false);
    },

    updateDisplay() {
      let index = 0;
      for (let i = 0; i < this.categories.length; i++) {
        if (this.categories[i].categoryDeleted) {
          continue;
        }

        this.categories[i].categoryDisplay = index++;
      }

      this.$eventBus.$emit("unSaved", true);
    },

    refreshCategory() {
      this.category = {
        categoryName: "",
        categoryDeleted: false,
        categoryDisplay: -1,
        item: [],
      };
    },

    validateInputCategory(category) {
      if (!category.categoryName || category.categoryName === "" || category.categoryName.trim() === "") {
        this.handleWarningMessage(detailMessages.emptyCategoryName);
        return false;
      }

      if (category.categoryName && category.categoryName.trim().length > maxLengthItem.lengthCategoryName) {
        this.handleWarningMessage(maxLengthItem.lengthCategoryName + detailMessages.overLengthCategoryName);
        return false;
      }

      return true;
    },

    updateResourceFields(resourceFields) {
      this.$emit("updateResourceField", [...resourceFields]);
    },

    async getJobResourceFields() {
      this.createLog(
        "Menu " +
          generalLabels.THIRD_TAB +
          "-Tab " +
          jobSettingProperty.DETAIL_INFORMATION_TAB_TITLE +
          "-Click button search " +
          screenLabelsProperties.SEARCH_JOB_LABEL
      );
      await this.$emit("sendLogger", this.log);
      this.$emit("getJobResourceFields", this.log.hash);
    },

    updateCompanyResourceFields(resourceFields) {
      this.$emit("updateCompanyResourceField", JSON.parse(JSON.stringify(resourceFields)));
    },

    async getCompanyResourceFields() {
      this.createLog("Menu " + generalLabels.THIRD_TAB + "-Tab " + jobSettingProperty.DETAIL_INFORMATION_TAB_TITLE + "-Click button search " + listLabelProperties.SEARCH_LABEL);
      await this.$emit("sendLogger", this.log);
      this.$emit("getCompanyResourceFields", this.log.hash);
    },

    updatedProperty(property) {
      this.$emit("updatedProperty", property);
    },

    logChangeData() {
      this.$eventBus.$emit("unSaved", true);
    },

    async closePopupDeleteItem() {
      await this.$emit(
        "createLogger",
        "Menu " +
          generalLabels.THIRD_TAB +
          "-Tab " +
          jobSettingProperty.DETAIL_INFORMATION_TAB_TITLE +
          "-Popup confirm delete item" +
          "-Click button " +
          labelProperties.buttonCancel
      );
      this.isVisibleModalConfirmDeleteItem = false;
      this.$emit("updateEditingStatus", false);
    },

    async addItemToCategory(categoryIndex, itemIndex) {
      if (!this.validateInput(this.item)) {
        return;
      }
      await this.$emit(
        "createLogger",
        "Menu " +
          generalLabels.THIRD_TAB +
          "-Tab " +
          jobSettingProperty.DETAIL_INFORMATION_TAB_TITLE +
          "-Popup add item-Click button " +
          labelProperties.buttonReflect
      );
      if (itemIndex === -1) {
        this.categories[categoryIndex].item.push(JSON.parse(JSON.stringify(this.item)));
      } else {
        this.categories[categoryIndex].item[itemIndex] = JSON.parse(JSON.stringify(this.item));
      }

      this.categories[categoryIndex].isCollapse = true;
      this.$emit("updateCategory", this.categories);
      this.$eventBus.$emit("unSaved", true);
      this.refreshItem();
      if (this.itemIndex === -1) {
        this.isVisibleEditItemModals[categoryIndex].status = false;
      } else {
        this.isVisibleEditItemModals[categoryIndex].subModal[itemIndex] = false;
      }

      this.$emit("updateEditingStatus", false);
    },

    async closeEditItemModal(index, subIndex) {
      this.createLog(
        "Menu " +
          generalLabels.THIRD_TAB +
          "-Tab " +
          jobSettingProperty.DETAIL_INFORMATION_TAB_TITLE +
          "-Popup edit item " +
          "-Click button " +
          labelProperties.buttonCancel
      );
      await this.$emit("sendLogger", this.log);
      this.$emit("getJobResourceFields", this.log.hash);
      this.$emit("getCompanyResourceFields", this.log.hash);
      this.refreshItem();
      this.isVisibleEditItemModals[index] = false;
      this.$emit("updateEditingStatus", false);
    },

    refreshItem() {
      this.item = {
        itemName: "",
        itemDeleted: false,
        resourceField: [],
      };
    },

    validateInput(item) {
      if (
        !item.itemName ||
        item.itemName === "" ||
        item.itemName.trim() === ""
      ) {
        this.handleWarningMessage(this.notification.emptyItemName);
        return false;
      }

      if (
        item.itemName &&
        item.itemName.trim().length > this.maxLengthItem.lengthItemName
      ) {
        this.handleWarningMessage(
          this.maxLengthItem.lengthItemName + this.notification.overLength
        );
        return false;
      }

      if (this.checkResourceLength(item) === 0) {
        this.handleWarningMessage(this.notification.dragDropItem);
        return false;
      }

      return true;
    },

    handleWarningMessage(message) {
      Vue.$toast.clear();
      Vue.$toast.warning(message, {
        position: "bottom-right",
        duration: 3000,
      });
    },

    checkResourceLength(item) {
      return item.resourceField.filter(resource => !resource.itemResourceDeleted).length;
    },

    async refreshResourceList() {
      this.createLog(
        "Menu " +
          generalLabels.THIRD_TAB +
          "-Tab " +
          jobSettingProperty.DETAIL_INFORMATION_TAB_TITLE +
          "-Click button" +
          screenLabelsProperties.REFRESH_RESOURCE_BUTTON
      );
      await this.$emit("sendLogger", this.log);
      this.$emit("refreshResourceList", this.log.hash);
    },

    async refreshCompanyResourceList() {
      this.createLog(
          "Menu " +
          generalLabels.THIRD_TAB +
          "-Tab " +
          jobSettingProperty.DETAIL_INFORMATION_TAB_TITLE +
          "-Click button" +
          screenLabelsProperties.REFRESH_RESOURCE_BUTTON
      );
      await this.$emit("sendLogger", this.log);
      this.$emit("refreshCompanyResourceList", this.log.hash);
    },

    createLog(action) {
      this.log.groupName = this.groupName;
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = action;
      this.log.info.path = window.location.href;
      this.log.info.userId = this.userId;
    },
  },
};
</script>
<style lang="css" scoped>
a:hover {
  color: #db8f57;
  text-decoration: unset;
  cursor: pointer;
}

.evt-click {
  text-decoration: none;
  color: #000;
  font-size: 17px;
}
.modal_confirm_delete_category{
  height: 230px !important;
}
.setting_options_search {
  height: 43px !important;
  position: initial;
  border-bottom: unset !important;
}
.setting_options_search_customize {
  top: 42px !important;
  border-bottom: 1px solid #ddd !important;
}
.setting_options_search_job_resource {
  background-color: #fff;
  padding: 16px;
  height: 45px;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.setting_content_sub {
  padding-top: 0px !important;
  min-height: unset !important;
}
.setting_options_wrapper {
  height: calc(50vh - 60px - 26px - 24px - 40px - 72px) !important;
  border-bottom: 1px solid #ddd !important;
}
.setting_category_company {
  color: #0095e7;
}
.setting_company_resource{
  border-top: 1px solid #ddd;
}
.justify-content-end{
  justify-content: space-between !important;
}

.setting_word_break {
  word-break: break-all;
}
</style>
